import { efficiencyBand, percentileOf } from '../../../src/features/cron-calculator/cron-calculator-math.js';
import { api, el, fmt, itemIcon, LABELS } from './dom.js';

const MAX_COMPARE = 6;

// Classe de cor de um Cron/Pérola relativa à distribuição histórica atual.
export function bandFor(value, stats) {
  if (!(value > 0) || stats.distribution.length < stats.minHistorySample) return 'unknown';
  return efficiencyBand(percentileOf(stats.distribution, value), stats.bandThresholds);
}

export function createPackageHistory(root, options, { getStats, onCompare, onEdit }) {
  const state = { page: 1, selected: new Map() };
  const form = root.querySelector('#mcHistoryFilters');
  const tableBody = root.querySelector('#mcHistoryRows');
  const status = root.querySelector('#mcHistoryStatus');
  const pagination = root.querySelector('#mcHistoryPagination');
  const compareButton = root.querySelector('#mcCompareButton');

  options.regions.forEach((region) => form.elements.region.add(new Option(LABELS.regions[region] || region, region)));
  options.packageTypes.forEach((type) => form.elements.type.add(new Option(LABELS.packageTypes[type] || type, type)));

  function query() {
    const params = new URLSearchParams({ page: String(state.page) });
    for (const [key, value] of new FormData(form)) if (String(value).trim()) params.set(key, String(value).trim());
    return params;
  }

  function updateCompareButton() {
    compareButton.textContent = `Comparar (${state.selected.size})`;
    compareButton.disabled = state.selected.size < 2;
  }

  function row(item) {
    const stats = getStats();
    const checkbox = el('input', { type: 'checkbox', 'aria-label': `Selecionar ${item.packageName} para comparar` });
    checkbox.checked = state.selected.has(item.id);
    checkbox.addEventListener('change', () => {
      if (checkbox.checked && state.selected.size >= MAX_COMPARE) { checkbox.checked = false; status.textContent = `Compare até ${MAX_COMPARE} ofertas por vez.`; return; }
      if (checkbox.checked) state.selected.set(item.id, item); else state.selected.delete(item.id);
      updateCompareButton();
    });
    const band = bandFor(item.cronPerPearl, stats);
    const nameCell = el('td', { className: 'mc-cell-name' }, [
      el('strong', {}, [item.packageIconPath ? itemIcon(item.packageIconPath, { size: 'sm' }) : null, item.packageName]),
      el('small', { text: `${LABELS.packageTypes[item.packageType] || ''} · ${LABELS.regions[item.region] || item.region}` }),
      el('small', { className: 'mc-author' }, ['por ', el('b', { text: item.isOwner ? 'você' : (item.ownerName || 'jogador') })])
    ]);
    if (item.isOwner) nameCell.append(el('button', { type: 'button', className: 'mc-link-button', text: 'Editar', onclick: () => onEdit(item) }));
    return el('tr', {}, [
      el('td', {}, [checkbox]),
      el('td', { 'data-label': 'Data', text: fmt.date(item.purchasedAt) }),
      nameCell,
      el('td', { 'data-label': 'Pérolas', className: 'num', text: fmt.int(item.originalPrice) }),
      el('td', { 'data-label': 'Desconto', className: 'num', text: fmt.pct(item.discountPercent) }),
      el('td', { 'data-label': 'Pérolas pagas', className: 'num', text: fmt.int(item.effectivePearls) }),
      el('td', { 'data-label': 'Crons', className: 'num', text: fmt.int(item.totalCrons) }),
      el('td', { 'data-label': 'Cron/Pérola', className: 'num' }, [el('span', { className: `mc-cpp mc-band-${band}`, title: LABELS.bands[band].label, text: fmt.cpp(item.cronPerPearl) })])
    ]);
  }

  async function load() {
    status.textContent = 'Carregando histórico...';
    try {
      const data = await api(`/api/tools/cron-calculator/purchases?${query()}`);
      tableBody.replaceChildren(...data.items.map(row));
      if (!data.items.length) tableBody.replaceChildren(el('tr', {}, [el('td', { colspan: '8', className: 'mc-empty', text: 'Nenhuma compra registrada com esses filtros.' })]));
      pagination.replaceChildren(...Array.from({ length: Math.min(data.pages, 20) }, (_, index) => {
        const page = index + 1;
        return el('button', { type: 'button', className: page === data.page ? 'active' : '', text: String(page), onclick: () => { state.page = page; load(); } });
      }));
      status.textContent = `${fmt.int(data.total)} registros encontrados.`;
    } catch (error) {
      status.textContent = error.message;
    }
  }

  let timer;
  form.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => { state.page = 1; load(); }, 350); });
  form.addEventListener('submit', (event) => { event.preventDefault(); state.page = 1; load(); });
  compareButton.addEventListener('click', () => onCompare([...state.selected.values()]));
  root.querySelector('#mcCompareClear').addEventListener('click', () => { state.selected.clear(); updateCompareButton(); load(); onCompare([]); });
  updateCompareButton();
  return { load, search: (text) => { form.elements.q.value = text; state.page = 1; load(); } };
}
